module.exports = __webpack_public_path__ + "static/media/tuna-all-products.b5f388ae.png";